import { useSelector } from 'react-redux';
import React from 'react';
import ErrorMessage from '../components/ErrorMessage';
import STLContainer from '../components/STLContainer';
import './Widget.scss';

export const WidgetContainer = () => {
	const { impact, emt, deviceType } = useSelector(
		(state) => state.widgetData
	);

	return impact && emt ? (
		<STLContainer impact={impact} emt={emt} deviceType={deviceType} />
	) : (
		<ErrorMessage />
	);
};

export default WidgetContainer;
